export const GET_ALL_REVIEW = "REVIEW/GET_ALL_REVIEW";
export const ADD_REVIEW = "REVIEW/ADD_REVIEW";
export const save_error_msg = "REVIEW/save_error_msg";
export const msg_false = "REVIEW/msg_false";
export const error_msg_false = "REVIEW/error_msg_false";